import React, { FC, ReactNode } from 'react';

interface SearchResultGroupProps {
  children: ReactNode;
  title: ReactNode;
}

export const SearchResultGroup: FC<SearchResultGroupProps> = ({
  children,
  title,
}) => {
  return (
    <div className="box-border text-center">
      <div className="text-text300 mb-0 mt-2.5 box-border pl-2.5 text-left text-sm capitalize">
        {title}
      </div>
      <hr className="mx-2.5 my-2.5 box-content h-0 overflow-visible border-t border-solid border-t-[rgba(0,0,0,0.1)] bg-[#4f5794]" />
      <ul className="mb-0 mt-0 box-border flex list-none flex-col p-0">
        {children}
      </ul>
    </div>
  );
};
